export enum EarlyAccessEnum {
  ALL = 'ALL',
  ROLE_EDIT = 'ROLE_EDIT',
  TRANSFER_ACCOUNT = 'TRANSFER_ACCOUNT',
  RECURSIVE_PERMANENT_DELETE = 'RECURSIVE_PERMANENT_DELETE',
  ZIP_UPLOAD = 'ZIP_UPLOAD',
  STYLES = 'STYLES',
  ALTINN = 'ALTINN',
  CHAT_TRANSCRIPTIONS = 'CHAT_TRANSCRIPTIONS',
  ORGBRAIN_SUPPORT = 'ORGBRAIN_SUPPORT',
  OPENAI = 'OPENAI',
  ORG_AUTH = 'ORG_AUTH',
  INVESTORIMPORT = 'INVESTORIMPORT',
  REDUCED_RELOAD = 'REDUCED_RELOAD',
  AGENDA_ITEMS_COMMENTS = 'AGENDA_ITEMS_COMMENTS',
  HIDE_SIGNING_TEXT = 'HIDE_SIGNING_TEXT',
  SHARED_FILES = 'SHARED_FILES',
  RING = 'RING',
  AI_SEARCH = 'AI_SEARCH',
}

// if deprecated grant access to all users
//  At some point tidy up the code and remove early access ?
export const deprecatedEarlyAccessMap: { [key in EarlyAccessEnum]?: boolean } = {
  [EarlyAccessEnum.ORGBRAIN_SUPPORT]: true,
  [EarlyAccessEnum.OPENAI]: true,
  [EarlyAccessEnum.SHARED_FILES]: true,
};

export type EarlyAccessMap = { [key in EarlyAccessEnum]: boolean };

export const earlyAccessScopes: {
  // We should use this to distinguish user and org access
  // Not all early access features are relevant for orgs
  [key in EarlyAccessEnum]: { organization: boolean; user: boolean };
} = {
  [EarlyAccessEnum.ALL]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.ROLE_EDIT]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.TRANSFER_ACCOUNT]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.RECURSIVE_PERMANENT_DELETE]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.ZIP_UPLOAD]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.STYLES]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.ALTINN]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.ORGBRAIN_SUPPORT]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.OPENAI]: {
    organization: true,
    user: true,
  },
  [EarlyAccessEnum.ORG_AUTH]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.INVESTORIMPORT]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.REDUCED_RELOAD]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.AGENDA_ITEMS_COMMENTS]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.HIDE_SIGNING_TEXT]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.SHARED_FILES]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.RING]: {
    organization: false,
    user: true,
  },
  [EarlyAccessEnum.AI_SEARCH]: {
    organization: true,
    user: false,
  },
  [EarlyAccessEnum.CHAT_TRANSCRIPTIONS]: {
    organization: false,
    user: true,
  },
};

export const allOrganizationEarlyAccessEnumValues = Object.values(EarlyAccessEnum).filter(
  (ea) => earlyAccessScopes[ea]?.organization && !deprecatedEarlyAccessMap[ea]
);
